module.exports = __webpack_public_path__ + "img/green_050.591990fb.png";